import React from 'react'

import { StandingAreaLabel } from './StandingAreaLabel'
import { SeatLabel } from './SeatLabel'
import { SeatLabelMin } from './SeatLabelMin'
import { TableLabel } from './TableLabel'
import { SEAT_GROUP_TYPES } from '../constants'

const MouseLabel = React.memo((props) => {
  const { onReservationButtonClick } = props
  let reservationButtonRef = null
  let labelRef = null

  const avoidBubblingEvent = (e) => {
    e.preventDefault()
  }

  const initializeListeners = (element) => {
    if (element !== null) {
      element.addEventListener('touchstart', avoidBubblingEvent)
      element.addEventListener('touchend', avoidBubblingEvent)
    } else if (labelRef !== null) {
      labelRef.removeEventListener('touchstart', avoidBubblingEvent)
      labelRef.removeEventListener('touchend', avoidBubblingEvent)
    }
    labelRef = element
  }

  const handleOnTouchEnd = (e) => {
    e.isFromLabelReservationButton = true
    onReservationButtonClick(e)
  }

  const initializeReservationButtonListeners = (element) => {
    if (element !== null) {
      element.addEventListener('touchend', handleOnTouchEnd)
    } else if (reservationButtonRef !== null) {
      reservationButtonRef.removeEventListener('touchend', handleOnTouchEnd)
    }
    reservationButtonRef = element
  }

  if (props.visible) {
    if (props.sgType === SEAT_GROUP_TYPES.STANDING) {
      return (
        <StandingAreaLabel
          {...props}
          initializeListeners={initializeListeners}
          initializeReservationButtonListeners={
            initializeReservationButtonListeners
          }
        />
      )
    } else if (props.is_PPP) {
      return <SeatLabelMin {...props} />
    } else if (props.isTableMap) {
      return (
        <TableLabel
          {...props}
          initializeListeners={initializeListeners}
          initializeReservationButtonListeners={
            initializeReservationButtonListeners
          }
        />
      )
    } else {
      return (
        <SeatLabel
          {...props}
          initializeListeners={initializeListeners}
          initializeReservationButtonListeners={
            initializeReservationButtonListeners
          }
        />
      )
    }
  } else {
    return null
  }
})

export { MouseLabel }
